/* eslint-disable no-undef */

export default {
	name: "assign-vehicle-to-customer-user-modal",
	props: ["heading", "modalId", "showModal", "userId", "companyId"],
	emits: ["assignVehicleToCustomerUserModalOkClicked"],
	data() {
		return {
			customerVehicles: [],
			customerUserVehicles: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
		};
	},
	methods: {
		getCustomerVehicleList(){
			let request = {
				companyId: this.companyId,
				isActive: true,
			};
			customerService.getCompanyVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerVehicles = successResponse.data.result;
						this.customerVehicles = dataTableHelper.castFieldValues(this.customerVehicles);
						this.getCustomerAssignedVehicles();
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			
		},
		getCustomerAssignedVehicles(){
			let request = {
				companyId: this.companyId,
				userId: this.userId
			};
			customerService.getCompanyVehiclesAssignedToUser(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerUserVehicles = successResponse.data.result;
						this.customerUserVehicles = dataTableHelper.castFieldValues(this.customerUserVehicles);
						for(let i = 0; i < this.customerVehicles.length; i++){
							for(let j = 0; j < this.customerUserVehicles.length; j++){
								this.customerVehicles[i].assigned = false;
								if(this.customerVehicles[i].vehicleId === this.customerUserVehicles[j].vehicleId){
									this.customerVehicles[i].assigned = true;
									break;
								}
							}
						}
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		clearMessageAlerts(){
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;

			this.$emit("assignVehicleToCustomerUserModalOkClicked", true);
		},
		onModalCloseClick() {
			this.$emit("assignVehicleToCustomerUserModalOkClicked", true);
		},
		onModalSaveClick(){
			//save changes
			this.loading = true;
			this.showErrorMessage = false;
			this.errorMessage = null;

			this.showSuccessMessage = false;
			this.successMessage = null;
			
			let vehicleIdsToAssign = [];
			let vehicleIdsUnassigned = [];
			for(let i = 0; i < this.customerVehicles.length; i++){
				if(this.customerVehicles[i].assigned){
					vehicleIdsToAssign.push(this.customerVehicles[i].vehicleId);
				}
				else{
					vehicleIdsUnassigned.push(this.customerVehicles[i].vehicleId);
				}
			}
			
			let request = {
				vehicleIdsToAssign: vehicleIdsToAssign,
				vehicleIdsToUnassign: vehicleIdsUnassigned,
				userId: this.userId,
				companyId: this.companyId
			};
			customerService.assignAndUnassignVehiclesFromCustomerUsers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.showSuccessMessage = true;
						this.successMessage = "Vehicles Assigned to Customer User Successfully";
						this.loading = false;
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = "Failed to Assign Vehicles Assigned to Customer User";
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = "Failed to Assign Vehicles Assigned to Customer User";
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		// companyId:{
		// 	handler: function () {
		// 		if(this.companyId !== null && this.companyId > 0){
		// 			this.getCustomerVehicleList();
		// 		}
		// 	},
		// 	immediate: true,
		// 	deep: true
		// }
		userId:{
			handler: function () {
				if(this.userId !== null && this.userId > 0){
					this.getCustomerVehicleList();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
